import React from 'react';
import T from 'prop-types';

import skeletons from '../Skeletons';
import Tooltip from '../../../../Tooltip';
import SimpleCard from '../../../../Card/SimpleCard';
import ErrorStateWithReload from '../../../../ErrorStateWithReload';

import { numberToHumanSummary } from '../../../../../utils/formatter';
import { isUnified } from '../../../../../utils/helpers';

const PubContribution = ({ data, settings, onPubQuickViewOpen }) => {
  if (settings.error) {
    return <ErrorStateWithReload />;
  }

  const handleClickPublisher = (event, link) => {
    event.preventDefault();
    event.stopPropagation();
    const [, , store, ref_no] = link.split('/');
    onPubQuickViewOpen({
      kind: isUnified(store) ? 'unified_publisher' : 'publisher',
      ref_no,
      store,
    });
  };

  return (
    <SimpleCard
      className="pub-contribution-qv"
      headerLeft={
        <>
          <h4 className="h4">Publisher Contribution</h4>
          <span>Last 30d</span>
        </>
      }
    >
      {settings.pending && skeletons.pubContribution}
      {!settings.pending && (
        <div className="pub-contribution-qv__content-table">
          <div className="pub-contribution-qv__content-table-head">
            <div className="pub-contribution-qv__content-table-head-item">Publisher</div>
            <div className="pub-contribution-qv__content-table-head-item"># of Apps</div>
            <div className="pub-contribution-qv__content-table-head-item">Downloads</div>
            <div className="pub-contribution-qv__content-table-head-item">MAU</div>
          </div>
          <div className="pub-contribution-qv__content-table-body">
            {data.publishers_performance?.map((item) => (
              <div key={item.name} className="pub-contribution-qv__content-table-body-item">
                {item.name !== 'All Others' ? (
                  <Tooltip
                    content={item.name}
                    colorVariant="light"
                    overlayClassName="data-strength-indicator-tooltip"
                  >
                    <div
                      className="pub-contribution-qv__content-table-body-item-name text-truncate text-blue text-underline cursor-pointer"
                      onClick={(e) => handleClickPublisher(e, item.url)}
                    >
                      {item.name}
                    </div>
                  </Tooltip>
                ) : (
                  <div className="pub-contribution-qv__content-table-body-item-name text-truncate">
                    <span>{item.name}</span>
                  </div>
                )}

                {item.name === 'All Others' ? (
                  <div className="pub-contribution-qv__content-table-body-item-value">
                    {numberToHumanSummary(item.apps_count)}
                  </div>
                ) : (
                  <div className="pub-contribution-qv__content-table-body-item-value">
                    {numberToHumanSummary(item.apps_count)}
                  </div>
                )}
                <div className="pub-contribution-qv__content-table-body-item-value">
                  {numberToHumanSummary(item.downloads?.value)}
                </div>
                <div className="pub-contribution-qv__content-table-body-item-value">
                  {numberToHumanSummary(item.mau?.value)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </SimpleCard>
  );
};

PubContribution.propTypes = {
  data: T.shape({
    publishers_performance: T.array,
  }).isRequired,
  settings: T.shape({
    error: T.bool,
    pending: T.bool,
  }).isRequired,
  onPubQuickViewOpen: T.func.isRequired,
};

export default PubContribution;
